var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "div",
        { attrs: { align: "left" } },
        [
          _c("v-flex", [
            _c(
              "h2",
              {
                staticClass: "h2_title",
                staticStyle: { "margin-top": "12px !important" }
              },
              [_vm._v("Detalles")]
            )
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c(
            "v-layout",
            { staticClass: "ml-5", attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", sm4: "", md4: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Buscar", outlined: "" },
                    on: {
                      keyup: function($event) {
                        return _vm.gridApi.setQuickFilter(_vm.filtro)
                      }
                    },
                    model: {
                      value: _vm.filtro,
                      callback: function($$v) {
                        _vm.filtro = $$v
                      },
                      expression: "filtro"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { xs2: "", sm2: "", md4: "" } }),
              _c("v-flex", { attrs: { xs3: "", sm3: "", md4: "" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-top": "6px",
                      "padding-right": "0px"
                    },
                    attrs: { align: "right" }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.accionExportar.visible,
                            expression: "accionExportar.visible"
                          }
                        ],
                        attrs: { flat: "", small: "", color: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.exportarExcel()
                          }
                        }
                      },
                      [
                        _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("cloud_download")
                        ]),
                        _c(
                          "span",
                          { staticClass: "importExportBtnTexto ml-1" },
                          [_vm._v("Exportar")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.accionCrear.visible,
                            expression: "accionCrear.visible"
                          }
                        ],
                        staticStyle: { "padding-right": "20px" },
                        attrs: {
                          color: "#ffe800",
                          disabled: _vm.solicitudAnulada
                        },
                        on: {
                          click: function($event) {
                            _vm.modalCrear = true
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticStyle: { color: "black" },
                            attrs: { dark: "", left: "" }
                          },
                          [_vm._v("add_circle_outline")]
                        ),
                        _c("span", { staticStyle: { color: "black" } }, [
                          _vm._v("Crear")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            { staticClass: "gridcard rounded-card EditarDetalleClientes" },
            [
              _vm.solicitudAnulada
                ? _c("MantenedorGrid", {
                    staticClass: "ag-theme-material",
                    attrs: { gridOptions: _vm.gridOptions }
                  })
                : _c("MantenedorGridSinCodigo", {
                    staticClass: "ag-theme-material",
                    attrs: {
                      gridOptions: _vm.gridOptions,
                      funcionalidadId: _vm.funcionalidad
                    }
                  })
            ],
            1
          )
        ],
        1
      ),
      _vm.modalCrear
        ? _c("CrearCliente", {
            attrs: { clientes: _vm.clientes },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.cerrarModal()
              },
              clienteCreado: function($event) {
                return _vm.agregarCliente($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }